"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MutableObserver = /** @class */ (function () {
    function MutableObserver() {
        this.nextCallback = function () { };
    }
    MutableObserver.prototype.setNext = function (next) {
        this.nextCallback = next;
    };
    MutableObserver.prototype.next = function (value) {
        return this.nextCallback(value);
    };
    return MutableObserver;
}());
exports.MutableObserver = MutableObserver;
//# sourceMappingURL=mutable-observer.js.map